module.exports = __webpack_public_path__ + "img/10ne.8f9f47b4.svg";